<script>
/**
 * Automodal
 *
 * Version 1.1
 * Se pasa a ui-edit-auto-modal el parámetro :form-id, requerido para el controld de borrado.
 *
 * Version 1.0
 * Placeholder base
 */

import _ from "lodash";
import mobiscroll from "@mobiscroll/javascript";

import { mapGetters, mapMutations } from 'vuex'

import { getArchetype, automodalHandler, beginingLabel, cookingLabel, packagingLabel, finishedLabel } from "./archetype";
import { handleFields } from './hidden-fields'

import calculoPorReceta from "../calculoPorReceta.vue";
import AlimentosTabs from "./alimentos-tabs.vue";
import PedidoDetalles from './pedido-detalles.vue';
import PreparacionInputs from './preparacion-inputs.vue';
import CookingInputs from './cooking-inputs.vue';
import PackagingInputs from './packaging-inputs.vue';
import finishedInputs from './finished-inputs.vue'

export default {
	name: "alimentosAutomodal",
	components: { calculoPorReceta, AlimentosTabs, PedidoDetalles, PreparacionInputs, CookingInputs, PackagingInputs, finishedInputs },
	props: {
		keepOnSuccess: {
			type: Boolean,
			default: false
		},
		conceptId: {
			type: [String, Number],
		},
		archetype: {
			type: [Array, Object],
			default: getArchetype,
		},
	},
	data: () => {
		return {
			hideButtons: false,
			selectedTab: null,
            beginingLabel,
            cookingLabel,
            packagingLabel,
            finishedLabel,
			abatimientoEmmited: {
                costo: 0,
                precio: 0
            },
			devEmmited: {
                costo: 0,
                precio: 0
            },
            uiRendimiento: false,
			form: {
				id: null,
				devolucionesCFG: []
			},
			asides: {
				cocineros: [],
				recetas: [],
				pedidodetalles: [],
				elementosAbatimiento: []
			},
		};
	},
	computed: {
        ...mapGetters(['uiGetReduceUiRendimiento']),
		cArchetype() {
			let updated = [],
				archetype = getArchetype();
			_.forEach(handleFields(_.clone(archetype), this.form.estatus), (itemsRow) => {

				if (!_.isArray(itemsRow)) {
					updated.push(itemsRow);
					return;
				}

				let adding = [];

				_.forEach(itemsRow, (item) => {

					// EVALUACIÓN DINÁMICA POR ELEMENTO DE ARQUETIPO
					if (item.key == "usuario_id_responsable") {
						item.options = this.asides.cocineros;
					}

					if (item.key == "encabezados_id") {
						item.options = this.asides.recetas;
					}

					adding.push(item);
				});
				updated.push(adding);
			});
			return updated;
		},
		calculos(){
			let costo = _.clone(this.form.costo_total),
				precio = _.clone(this.form.precio_total),
				costo_unitario = 0, 
				precio_unitario = 0;
			
			costo_unitario = this.keepItPositive((( costo - this.devEmmited.costo + this.abatimientoEmmited.costo ) / this.form.porciones).toFixed(2))
			precio_unitario = this.keepItPositive((( precio - this.devEmmited.precio + this.abatimientoEmmited.precio ) / this.form.porciones).toFixed(2))

			return {costo, precio, costo_unitario, precio_unitario}
		}
	},
	methods: {
        ...mapMutations(['uiSetReduceUiRendimiento']),
		updateFromPackaging(abatimientoEmmited){
			console.log('abatimientoEmmited', abatimientoEmmited)
			this.abatimientoEmmited.costo = abatimientoEmmited.costo
			this.abatimientoEmmited.precio = abatimientoEmmited.precio
			this.updateCostoInicialDinamico()
		},
		getDevolutionAmount(devolutionAccount) {
			this.devEmmited.costo = devolutionAccount.costo
			this.devEmmited.precio = devolutionAccount.precio
			this.updateCostoInicialDinamico()
		},
		keepItPositive(num) {
  			return (num == Infinity || isNaN(num)) ? 0 : num
		},
		presetTitle(){
			try {
				if(this.form.encabezados_id){
					let found = _.find(this.asides.recetas, {value: this.form.encabezados_id})
					this.form.titulo_preparacion = found.text
				} else {
					throw 'Encabezado no seleccionado';
				}
			} catch(e){
				console.warn(e)
				this.form.titulo_preparacion = '';
			}
		},
		async aplicarAbatimiento($event){
			let bck = _.clone(this.form.estatus)
			this.form.estatus = _.clone(finishedLabel);
			this.$refs.automodal.updateFromModel()
			let response = await this.$refs.automodal.onSubmit($event);
			console.log("response.aplicarAbatimiento", response)
			this.hideButtons = true;
			if(response.status){
				this.form.estatus = _.clone(packagingLabel);
				this.$refs.automodal.define();
				this.selectedTab = _.clone(finishedLabel);
			} else {
				this.form.estatus = bck
				this.$refs.automodal.updateFromModel()
			}
			this.hideButtons = false;
		},
		async pasarAAbatimiento($event){
			let bck = _.clone(this.form.estatus)
			this.form.estatus = _.clone(packagingLabel);
			this.$refs.automodal.updateFromModel()
			let response = await this.$refs.automodal.onSubmit($event);
			console.log("response.pasarAAbatimiento", response)
			this.hideButtons = true;
			if(response.status){
				this.form.estatus = _.clone(cookingLabel);
				this.$refs.automodal.define();
				this.selectedTab = _.clone(packagingLabel);
			} else {
				this.form.estatus = bck
				this.$refs.automodal.updateFromModel()
			}
			this.hideButtons = false;
		},
		async generarDevolucion($event){
			let bck = _.clone(this.form.estatus)
			this.form.estatus = _.clone(cookingLabel);
			this.$refs.automodal.updateFromModel()
			let response = await this.$refs.automodal.onSubmit($event);
			console.log("response.generarDevolucion", response)
			this.hideButtons = true;
			if(response.status){
				this.form.estatus = _.clone(beginingLabel);
				this.$refs.automodal.define();
				this.selectedTab = _.clone(cookingLabel);
			} else {
				this.form.estatus = bck
				this.$refs.automodal.updateFromModel()
			}
			this.hideButtons = false;
		},
		getHandler() {
			return automodalHandler(this.conceptId);
		},
		refresh() {
			this.$emit("refresh");
		},
		checkAsides() {
			const asides = this.$refs.automodal.getAsides();
			if (!!asides) {
				this.asides.cocineros 				= asides.cocineros;
				this.asides.recetas 				= asides.recetas;
				this.asides.pedidodetalles 			= asides.pedidodetalles;
				this.asides.elementosAbatimiento 	= asides.elementosAbatimiento
			}
		},
		onDisplay() {
			// SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL HA CARGADO DOM COMPLETAMENTE.
			if(!this.form.id){
				mobiscroll.select("#form-encabezados_id", {
					inputClass: "custom-select",
					filter: true,
				});
				this.selectedTab = beginingLabel
			} else {
				this.selectedTab = _.clone(this.form.estatus)
			}
		},
		onHidden(bvEvent, modalId){
			console.log(bvEvent, modalId)
		},
		updateCostoInicialDinamico(){
			this.form.costo_total = this.calculos.costo
			this.form.precio_total = this.calculos.precio
			this.form.precio_unitario = this.calculos.precio_unitario
			this.form.costo_unitario = this.calculos.costo_unitario
		}
	},
	watch: {
        uiRendimiento(){
            this.uiSetReduceUiRendimiento(this.uiRendimiento)
        },
		"form.encabezados_id"() {
			if(!this.form.id)
				this.presetTitle()
		},
		"form.porciones"() {
			this.updateCostoInicialDinamico()
		},
		"form.calculoInicial"() {
			console.log(this.form.calculoInicial);
			if (_.isObject(this.form.calculoInicial)) {
				this.form.costo_total = parseFloat(
					this.form.calculoInicial.costoGeneral
				).toFixed(2);
				this.form.precio_total = parseFloat(
					this.form.calculoInicial.precioGeneral
				).toFixed(2);
				this.form.costo_unitario = parseFloat(
					this.form.calculoInicial.costoGeneral / this.form.porciones
				).toFixed(2);
				this.form.precio_unitario = parseFloat(
					this.form.calculoInicial.precioGeneral / this.form.porciones
				).toFixed(2);
			} else {
				this.form.costo_total = 0.0;
				this.form.precio_total = 0.0;
				this.form.costo_unitario = 0.0;
				this.form.precio_unitario = 0.0;
			}
		},
		"form.id"() {}
	},
    mounted() {
        this.uiRendimiento = _.clone(this.uiGetReduceUiRendimiento)
    }
};
</script>

<template>
	<ui-edit-auto-modal  ref="automodal" size="xl"

		v-model="form"

		@refresh="refresh()"
		@defined="checkAsides()"
		@display="onDisplay"
		@hidden="onHidden"

		:keepOnSuccess="keepOnSuccess"
		:hide-buttons="hideButtons"

		:label="(form.id) ? 'Preparación #' + form.id : 'Nueva preparación'"

		:form-id="form.id"
		:form-archetype="cArchetype"
		:handler="getHandler()"
		:cancel-label=false
		:allow-aside="true"
		:allow-delete="true">

		<slot name="default"><i class="fa fa-cog"></i></slot>

		<b-col slot="aside" md="8">

			<!--TAB SELECTOR -->
			<alimentos-tabs v-model="selectedTab" :current-estatus="form.estatus"/>

			<!-- TAB CONTENTS -->
			<div id="BeginningTab" class="mt-4" v-if="selectedTab == beginingLabel">

				<b-jumbotron v-if="!(form.encabezados_id && form.porciones) && !form.id"
					header="Detalle de cálculo" 
					lead="Especifica una receta y las porciones para continuar" />

				<preparacion-inputs v-else v-model="form" @updated="$refs.automodal.updateFromModel">
					<calculo-por-receta :key="'calc-by-' + uiRendimiento" v-model="form.calculoInicial" v-if="!form.id" 
						@updated="$refs.automodal.updateFromModel"
						:elementosId="form.encabezados_id"
						:porciones="form.porciones" />
					<pedido-detalles key="simple" v-else :resumen-pedido="asides.pedidodetalles" />
				</preparacion-inputs>

			</div>

			<div id="CookingTab" class="mt-4" v-if="selectedTab == cookingLabel">
				
				<cooking-inputs v-model="form" />

				<pedido-detalles key="form" v-model="form"
					:resumen-pedido="asides.pedidodetalles"
					:devoluciones="true"
					:readonly="!(form.estatus == cookingLabel)"
					@updated="getDevolutionAmount"/>
			</div>

			<div id="AbatimentoTab" class="mt-4" v-if="selectedTab == packagingLabel">
				<packaging-inputs :fullCatalog="asides.elementosAbatimiento" v-model="form" :readonly="form.estatus == 'Finalizada'" @updated="updateFromPackaging"/>
			</div>

			<div id="FinishedTab" class="mt-4" v-if="selectedTab == finishedLabel">
				<finished-inputs v-model="form"/>
			</div>

		</b-col>

        <b-col slot="bottom" v-if="!form.id">
            
            <b-form-group label="Rendimiento de presentación">
                <b-form-checkbox v-model="uiRendimiento"  switch>
                    <span v-if="uiGetReduceUiRendimiento">Considerar rendimiento</span>
                    <span v-else>Rendimiento ignorado</span>
                </b-form-checkbox>
            </b-form-group>

        </b-col>

		

		<b-button slot="extra-buttons" v-if="form.estatus == beginingLabel" @click="generarDevolucion($event)" variant="warning">Pasar a producción</b-button>
		<b-button slot="extra-buttons" v-if="form.estatus == cookingLabel" @click="pasarAAbatimiento($event)" variant="warning">Pasar a abatimiento</b-button>
		<b-button slot="extra-buttons" v-if="form.estatus == packagingLabel" @click="aplicarAbatimiento($event)" variant="warning">Finalizar abatimiento</b-button>

	</ui-edit-auto-modal>
</template>